/*
 * LD — Remove floating WhatsApp launchers site-wide.
 * Handles: normal DOM, Shadow DOM (open roots), iframes, late injection.
 * Footer and inline WhatsApp links are preserved.
 */
(function () {
  var KEYS = ['whatsapp', 'wa.me', 'watsapp', 'wapp', 'wa-chat', 'wa_chat'];
  var SAFE = '.ld-footer, footer, header, .ldbar, .ldnav, #main-content';

  function looksLikeWA(el) {
    try {
      var bits = [
        typeof el.className === 'string' ? el.className : '',
        el.id || '',
        el.getAttribute && (el.getAttribute('href') || ''),
        el.getAttribute && (el.getAttribute('src') || ''),
        el.getAttribute && (el.getAttribute('aria-label') || ''),
        el.getAttribute && (el.getAttribute('title') || ''),
        el.getAttribute && (el.getAttribute('data-testid') || '')
      ].join(' ').toLowerCase();

      for (var i = 0; i < KEYS.length; i++) {
        if (bits.indexOf(KEYS[i]) > -1) return true;
      }

      if (el.querySelector) {
        if (el.querySelector('a[href*="wa.me"], a[href*="whatsapp"], iframe[src*="whatsapp"], img[src*="whatsapp"]')) return true;
      }
    } catch (e) {}
    return false;
  }

  function nuke(el) {
    try {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.setAttribute('data-ld-wa', 'removed');
    } catch (e) {}
  }

  function check(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
    if (el.getAttribute && el.getAttribute('data-ld-wa') === 'removed') return;

    var cs;
    try { cs = getComputedStyle(el); } catch (e) { return; }
    if (cs.position !== 'fixed' && cs.position !== 'sticky') return;

    var r;
    try { r = el.getBoundingClientRect(); } catch (e) { return; }
    if (r.width > 260 || r.height > 260) return;      /* leave real bars alone */
    if (r.width === 0 && r.height === 0) return;

    try { if (el.closest && el.closest(SAFE)) return; } catch (e) {}

    if (looksLikeWA(el)) nuke(el);
  }

  /* Walk normal DOM plus any open shadow roots */
  function walk(root, depth) {
    if (!root || depth > 6) return;
    var nodes;
    try { nodes = root.querySelectorAll('*'); } catch (e) { return; }

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      check(el);
      if (el.shadowRoot) {
        walk(el.shadowRoot, depth + 1);
        /* Hide the shadow host itself if its contents are a WA launcher */
        try {
          var inner = el.shadowRoot.innerHTML || '';
          var low = inner.toLowerCase();
          for (var k = 0; k < KEYS.length; k++) {
            if (low.indexOf(KEYS[k]) > -1) {
              var hcs = getComputedStyle(el);
              if (hcs.position === 'fixed' || hcs.position === 'sticky') nuke(el);
              break;
            }
          }
        } catch (e) {}
      }
    }
  }

  function sweep() {
    walk(document.body, 0);

    /* Fixed iframes pointing at a chat service */
    var frames = document.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      var src = (f.getAttribute('src') || '').toLowerCase();
      var id = ((f.id || '') + ' ' + (typeof f.className === 'string' ? f.className : '')).toLowerCase();
      var hit = false;
      for (var k = 0; k < KEYS.length; k++) {
        if (src.indexOf(KEYS[k]) > -1 || id.indexOf(KEYS[k]) > -1) { hit = true; break; }
      }
      if (!hit) continue;
      var cs;
      try { cs = getComputedStyle(f); } catch (e) { continue; }
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        nuke(f);
        if (f.parentElement) {
          try {
            var pcs = getComputedStyle(f.parentElement);
            if (pcs.position === 'fixed' || pcs.position === 'sticky') nuke(f.parentElement);
          } catch (e) {}
        }
      }
    }
  }

  function start() {
    sweep();

    var n = 0;
    var iv = setInterval(function () {
      sweep();
      if (++n > 25) clearInterval(iv);     /* ~30 seconds */
    }, 1200);

    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { sweep(); });
      try {
        mo.observe(document.documentElement, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 45000);
      } catch (e) {}
    }

    window.addEventListener('load', sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
